import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  countries: [],
  languages: [],
  marketSegments: [],
  exampleProjects: [],
  subTechnologies: [],
  waterLibraryList: {},
  translatedLanguages: [],
  defaultTechnologies: [],
  unreadNotifications: [],
  chemicalLibraryList: [],
  elementsData: [],
  roElementsDataByGroup: {},
  roElementsDataByIds: {},
  chemicalCategoryData: {},
  fullScreenData: null,
  defaultFeedSetup: null,
  compoundDefaults: [],
  fullScreenErrorData: null,
  fullScreenLoaderMessage: null,
  isAppUnderWarranty: false,
};

export const GlobalDataSlice = createSlice({
  name: "GlobalData",
  initialState,
  reducers: {
    updateGlobalData: (state, action) => {
      const { type, value } = action.payload;
      if (type && type in state) {
        state[type] = value;
      }
    },
    updateGlobalROElementsData: (state, action) => {
      Object.assign(state, action.payload);
    },
    updateIsAppUnderWarranty: (state, action) => {
      state.isAppUnderWarranty = action.payload;
    },
  },
});

export const { updateGlobalData, updateGlobalROElementsData, updateIsAppUnderWarranty } = GlobalDataSlice.actions;

export default GlobalDataSlice.reducer;
